import {
  configureInfraModules,
  type Framework,
  type FrameworkProvider,
  registerPiqueSchemas,
  setEdgelessModeHandler,
} from '@toeverything/infra';

import { setupAIProvider } from '../components/blocksuite/block-suite-editor/ai/setup-provider';
import {
  EdgelessElementGroupsBlockSchema,
  PiqueEmbedHtmlBlockSchema,
  PiqueEmbedYoutubeBlockSchema,
  PiqueLatexBlockSchema,
  PiqueListBlockSchema,
  PiqueMermaidBlockSchema,
  PiqueParagraphBlockSchema,
  PiqueQuizEmbedBlockSchema,
} from '../components/blocksuite/block-suite-editor/specs/custom/pique';
import { WorkbenchService } from './workbench';
import { CalendarService } from '../services/calendar-service';
import { TranscriptionService } from '../services/transcription-service';
import { configureCloudModule, FetchService } from './cloud';
import { configureCollectionModule } from './collection';
import { configureCreateWorkspaceModule } from './create-workspace';
import { configureDocLinksModule } from './doc-link';
import { configureDocsSearchModule } from './docs-search';
import { configureEditorModule } from './editor';
import { configureEditorSettingModule } from './editor-settting';
import { configureExplorerModule } from './explorer';
import { configureFavoriteModule } from './favorite';
import { configureFindInPageModule } from './find-in-page';
import { configureImportTemplateModule } from './import-template';
import { configureNavigationModule } from './navigation';
import { configureOrganizeModule } from './organize';
import { configurePeekViewModule } from './peek-view';
import { configurePermissionsModule } from './permissions';
import { configureWorkspacePropertiesModule } from './properties';
import { configureQuickSearchModule } from './quicksearch';
import { configureShareDocsModule } from './share-doc';
import { configureSystemFontFamilyModule } from './system-font-family';
import { configureTagModule } from './tag';
import { configureThemeEditorModule } from './theme-editor';

export function configureCommonModules(framework: Framework) {
  configureInfraModules(framework);

  registerPiqueSchemas([
    PiqueParagraphBlockSchema,
    PiqueListBlockSchema,
    PiqueEmbedYoutubeBlockSchema,
    PiqueEmbedHtmlBlockSchema,
    PiqueQuizEmbedBlockSchema,
    EdgelessElementGroupsBlockSchema,
    PiqueLatexBlockSchema,
    PiqueMermaidBlockSchema,
  ]);

  setEdgelessModeHandler((framework: FrameworkProvider) => {
    const workbench = framework.getOptional(WorkbenchService);
    if (workbench) {
      workbench.workbench.openCurrentDocBeside();
    }
  });
  configureCollectionModule(framework);
  configureNavigationModule(framework);
  configureTagModule(framework);
  configureWorkspacePropertiesModule(framework);
  configureCloudModule(framework);
  configurePermissionsModule(framework);
  configureShareDocsModule(framework);
  configureFindInPageModule(framework);
  configurePeekViewModule(framework);
  configureQuickSearchModule(framework);
  configureDocsSearchModule(framework);
  configureDocLinksModule(framework);
  configureOrganizeModule(framework);
  configureFavoriteModule(framework);
  configureExplorerModule(framework);
  configureThemeEditorModule(framework);
  configureEditorModule(framework);
  configureSystemFontFamilyModule(framework);
  configureEditorSettingModule(framework);
  configureImportTemplateModule(framework);
  configureCreateWorkspaceModule();
  framework.service(TranscriptionService, [FetchService]);
  framework.service(CalendarService);

  // Initialize AI provider
  setupAIProvider();
}
